import { IconChevronDown } from "@tabler/icons-react";
import { forwardRef } from "react";

import { UnstyledButton, UnstyledButtonProps } from "@/ui";
import { cn } from "@/utils/cn";

export type GlobalSelectButtonProps = {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  size?: "sm" | "md";
} & UnstyledButtonProps;

export const GlobalSelectButton = forwardRef<HTMLButtonElement, GlobalSelectButtonProps>(
  ({ title, subtitle, icon, className, size = "md", ...props }, ref) => {
    return (
      <UnstyledButton
        className={cn(
          "h-10 cursor-pointer shadow-none flex gap-3 py-2 px-4 rounded-medium justify-between",
          "outline-hidden ring-focus ring-offset-2 ring-offset-red/0 focus-visible:ring-2",
          {
            "border border-surface-2": size === "md",
          },
          className
        )}
        {...props}
        ref={ref}
      >
        <div className="flex gap-3 items-center min-w-0">
          <div className="flex items-center shrink-0">{icon}</div>
          {size === "md" && (
            <div className="flex flex-col min-w-0">
              <span className="text-tiny leading-tight! text-secondary font-normal truncate translate-y-[2px] text-left">
                {subtitle}
              </span>
              <span className="text-medium font-bold leading-tight! text-left truncate text-new-primary font-grotesk -translate-y-[2px]">
                {title}
              </span>
            </div>
          )}
        </div>
        <div className="flex items-center">
          <IconChevronDown className="text-foreground-500 font-normal" size={16} />
        </div>
      </UnstyledButton>
    );
  }
);
